if (!customElements.get('quick-shop-popup')) {
  class QuickShopPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.quickShopOptions = this.querySelectorAll('[data-quick-shop-popup-option]');
      this.openPopupButtons = this.querySelectorAll('[data-mobile-popup-toggle]');
      this.popupContainer = this.querySelector('[data-mobile-popup-container]');
      this.popupContent = this.querySelector('[data-mobile-popup-content]');
      this.closePopupButton = this.querySelector('[data-mobile-popup-close]');

      this?.querySelectorAll('[data-quick-shop-popup-option]').forEach((option, index) => {
        if (index === 0) {
          option
            .closest('.quick-shop__option-popup')
            .querySelector('.option__label_popup')
            .classList.add('option__label_popup--checked');
        }
      });

      this.openPopupButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.openPopup();
          this.disableBackgroundScroll();
        });
      });

      this.closePopupButton.addEventListener('click', () => {
        this.closePopup();
        this.enableBackgroundScroll();
      });

      this.popupContainer.addEventListener('click', (e) => {
        if (e.target === this.popupContainer) {
          this.closePopup();
          this.enableBackgroundScroll();
        }
      });

      // Bind option select events
      this?.querySelectorAll('[data-quick-shop-popup-option]').forEach((option) => {
        option.addEventListener('click', (e) => {
          const label = option
            ?.closest('.quick-shop__option-popup')
            ?.querySelector('.option__label_popup');
          this.updateLabelState(label);
          this.onOptionSelect(option.value, option.dataset.inventoryQuantity);
        });
      });
    }

    openPopup() {
      this.popupContainer.classList.remove('hidden');
      this.popupContainer.classList.add('flex');
      setTimeout(() => {
        this.popupContent.classList.remove('translate-y-full');
      }, 100);
    }

    closePopup() {
      this.popupContent.classList.add('translate-y-full');
      setTimeout(() => {
        this.popupContainer.classList.add('hidden');
      }, 100);
    }
    disableBackgroundScroll() {
      document.body.style.overflow = 'hidden';
    }

    enableBackgroundScroll() {
      document.body.style.overflow = '';
    }

    updateLabelState(label) {
      this.quickShopOptions.forEach((option) => {
        const optionLabel = option
          .closest('.quick-shop__option-popup')
          .querySelector('.option__label_popup');
        optionLabel.classList.remove('option__label_popup--checked');
      });
      label.classList.add('option__label_popup--checked');
    }

    onOptionSelect(variantId, inventoryQuantity) {
      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
      const submitButton = productForm.querySelector('[type="submit"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
      submitButton.click();
    }
  }

  customElements.define('quick-shop-popup', QuickShopPopup);
}
